import format from 'date-fns/format';
import { ru } from 'date-fns/locale';

export const getFormatedDate = (date: string | Date, formatType: string) =>
  format(new Date(date), formatType, {
    locale: ru,
  });
